import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import AuthShell, { Field } from "./AuthShell";
import api, { formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Reset your password" subtitle="We'll email you a secure reset link."
      footer={<Link to="/login" className="text-[#1D4ED8] font-semibold">← Back to sign in</Link>}>
      {sent ? (
        <div className="p-5 rounded-xl bg-emerald-50 border border-emerald-200 text-emerald-800">
          If that email is registered, a reset link has been sent. Check your inbox.
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <Field label="Email" data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" />
          <button data-testid="forgot-submit" disabled={loading} className="w-full py-3 rounded-full bg-[#1D4ED8] text-white font-semibold hover:bg-[#1E40AF] transition-colors disabled:opacity-60">
            {loading ? "Sending…" : "Send reset link"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
